/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_LaughInputs */

const fr_fancy_vast_otter_laugh = /** @type {(inputs: Fancy_Vast_Otter_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

/**

* @param {Fancy_Vast_Otter_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_laugh = /** @type {((inputs?: Fancy_Vast_Otter_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_laugh(inputs)
});